import React from 'react';
import styled from 'styled-components';
import { FlexContainer } from '../../styled/layout.styled';
import { H3 } from '../../styled/typograpghy.styled';
import Button from '../reusable/Button';

const StyledH3 = styled(H3)`
  margin: 0 0 16px 0;

  @media only screen and (max-width: 568px) {
    margin: 0 0 16px 0;
    font-size: 20px;
  }
`;

const StyledP = styled.p`
  width: 524px;
  text-align: center;
  margin: 0 0 40px 0;
  color: ${({ theme }) => theme.color.white};
  @media only screen and (max-width: 568px) {
    width: 312px;
  }
`;

const Suspended = () => (
  <>
    <FlexContainer padding="60px 0 365px 0" justifyContent="center" mobilePadding="40px 0 429px 0">
      <FlexContainer flexDirection="column" alignItems="center">
        <StyledH3>Account Suspended</StyledH3>
        <StyledP>
          Your partner account has been suspended due to suspicious activities. Please contact us to learn more.
        </StyledP>
        <FlexContainer
          width="536px"
          justifyContent="center"
          mobileFlexDirection="column"
          mobileHeight="116px"
          mobileJustifyContent="center"
          mobileAlignItems="center"
        >
          <a href="mailto:contact@peergame.com" target="_blank" rel="noreferrer noopener">
            <Button width="260px" buttonShape="bordered">
              Email
            </Button>
          </a>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  </>
);

export default Suspended;
